import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AllJobs from "../views/AllJobs.vue";
import AddJob from "../views/AddJob.vue";
import ViewJob from "../views/ViewJob.vue";
import EditJob from "@/views/EditJob.vue";
import Login from "@/views/UserLogin.vue";
import Register from "@/views/UserRegister.vue";
import { useAuthStore } from "@/stores/auth";
import NewJobSearch from "@/views/NewJobSearch.vue";

const routes: RouteRecordRaw[] = [
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/UserSettings.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    component: () => import("@/views/UserSubscriptions.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/billing",
    name: "Billing",
    component: () => import("@/views/UserBilling.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: () => import("@/views/UserCheckout.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { requiresGuest: true }
  },
  {
    path: "/",
    name: "AllJobs",
    component: AllJobs,
    meta: { requiresAuth: true }
  },
  {
    path: "/add",
    name: "AddJob",
    component: AddJob,
    meta: { requiresAuth: true }
  },
  {
    path: "/my-skills",
    name: "Skills",
    component: () => import("../views/MySkills.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/my-searches",
    name: "MySearches",
    component: () => import('../views/MySearches.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile-setup',
    name: 'ProfileSetup',
    component: () => import('@/views/ProfileSetup.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/new-job-search',
    name: 'NewJobSearch',
    component: NewJobSearch,
    meta: { requiresAuth: true }
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('@/views/UserSupport.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/support/:id',
    name: 'SupportTicket',
    component: () => import('@/views/UserSupportTicket.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/job-results/:id',
    name: 'JobResults',
    component: () => import('../views/JobResults.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/view/:id",
    name: "ViewJob",
    component: ViewJob,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/edit/:id",
    name: "EditJob",
    component: EditJob,
    props: true,
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard for authentication
router.beforeEach((to, _from, next) => {
  const isAuthenticated = useAuthStore().isAuthenticated;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresGuest = to.matched.some(record => record.meta.requiresGuest);

  if (requiresAuth && !isAuthenticated) {
    next({ name: 'Login', query: { redirect: to.fullPath } });
  } else if (requiresGuest && isAuthenticated) {
    next({ name: 'AllJobs' });
  } else {
    next();
  }
});

export default router;
